import React, { useEffect, useState, useRef } from "react";
import { SGeneralForms, SSegmentedTabs } from "shj-components";
import { whiteConfigSaveOrUpdateByRequest, findWhiteNodeResponseListByRequest } from '@/services/fmsConfig'
import { getEnum,httpDictServTenant } from '@/services/fmsServices'
import { Spin, message } from "antd";
const AddOrEdit = (props) => {
  const { editRef, setLoading, fn, record, onCancel } = props;
  const ref:any = useRef();
  const [nodesList, setNodesList] = useState([] as any[]);
  const [addOrEditFooterLoading, setAddOrEditFooterLoading] = useState(false);
  const onFormRef = () => {
    const { onFormRef } = ref.current || {};
    return onFormRef?.()
  }

  useEffect(() => {
    if(record?.id){
      onFormRef()?.setFieldsValue({...record,
        configNodeList: record?.configNodeResponseList?.map(item => item.nodeCode),
        configReceiptTypeList: record?.configReceiptTypeResponseList?.map(item => item.receiptType)
      })
    }
  }, [props.record]);

  const getOptions = async () => {
    setAddOrEditFooterLoading(true)
    let whiteTypeList = await httpDictServTenant({ parentKey: 'whiteType', enabled: 1 })//类型
    let receiptTypeList = await httpDictServTenant({ parentKey: 'receiptType', enabled: 1 })//收款类型
    let nodeList = await findWhiteNodeResponseListByRequest({})//节点
    setNodesList(nodeList)
    setAddOrEditFooterLoading(false)
    return Promise.resolve({
      whiteTypeList,
      nodeList,
      receiptTypeList
    })
  }

  const onFinish = () => {
    onFormRef()?.validateFields().then(values => {
      setLoading(true)
      // 转换数据格式
      const requestData = {
        ...values,
        configNodeList: values.configNodeList?.map(nodeCode => {
          const matchedNode = nodesList.find(node => node.nodeCode === nodeCode);
          return {
            nodeType: matchedNode?.nodeType || "",
            nodeCode,
            nodeName: matchedNode?.nodeName || ""
          };
        }),
        configReceiptTypeList: values.configReceiptTypeList?.map(priKey => ({
          receiptType: priKey
        }))
      }

      whiteConfigSaveOrUpdateByRequest(requestData).then((res)=>{
        setLoading(false)
        message.success('操作成功')
        onCancel()
        fn()
      }).finally(() => {
        setLoading(false)
      }) 
    })
  }

  if (editRef) editRef.onFinish = onFinish
  const reqMeg = '不能为空'
  return <Spin spinning={addOrEditFooterLoading}>
    <SGeneralForms
      initialValues={props.record}
      ref={ref}
      httpOptionsFn={getOptions}
      layout={'vertical'}
      titleMode={'edit'}
      configs={[{
        formItem: [
          { label: 'id', name: 'id', hidden: true },
          {
            label: '类型',
            name: 'whiteType',
            spanCol: 12,
            type: 'select',
            data: 'whiteTypeList',
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              fieldNames: { value: 'priKey', label: 'name' },
            },    
          },
          {
            label: '节点', name: 'configNodeList', spanCol: 12,
            type: 'select',
            data: 'nodeList',
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              mode: 'multiple',
              fieldNames: { value: 'nodeCode', label: 'nodeName' },
            },   
          },
          {
            label: '收款白名单', name: 'configReceiptTypeList', spanCol: 12,
            type: 'select',
            data: 'receiptTypeList',
            required: true,
            rules: [{ required: true, message: reqMeg }],
            comConfig: {
              mode: 'multiple',
              fieldNames: { value: 'priKey', label: 'name' },
            },   
          }
        ]
      }]}
    />
  </Spin>
}

export default AddOrEdit
